module.exports = __webpack_public_path__ + "static/media/ellipses.b5ab85e6.svg";